import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d62af67"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "admin-sports",
  class: "admin-card"
}
const _hoisted_2 = { class: "responsive-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "#", -1))
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left sport-action" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-heading" }, "id", -1))
const _hoisted_9 = { class: "cell-heading" }
const _hoisted_10 = { class: "sport-label" }
const _hoisted_11 = { class: "cell-heading" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "cell-heading" }
const _hoisted_14 = { class: "sport-action" }
const _hoisted_15 = { class: "cell-heading" }
const _hoisted_16 = { class: "action-button" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "has-workouts"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-warning",
  "aria-hidden": "true"
}, null, -1))

import { ComputedRef, computed } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { ROOT_STORE, SPORTS_STORE } from '@/store/constants'
  import { ITranslatedSport } from '@/types/sports'
  import { useStore } from '@/use/useStore'
  import { translateSports } from '@/utils/sports'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n()
  const store = useStore()

  const translatedSports: ComputedRef<ITranslatedSport[]> = computed(() =>
    translateSports(store.getters[SPORTS_STORE.GETTERS.SPORTS], t)
  )
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )

  function updateSportStatus(id: number, isActive: boolean) {
    store.dispatch(SPORTS_STORE.ACTIONS.UPDATE_SPORTS, {
      id,
      isActive,
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_SportImage = _resolveComponent("SportImage")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('admin.SPORTS.TITLE')), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("button", {
          class: "top-button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push('/admin')), ["prevent"]))
        }, _toDisplayString(_ctx.$t('admin.BACK_TO_ADMIN')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_3,
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('admin.SPORTS.TABLE.IMAGE')), 1),
                _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('admin.SPORTS.TABLE.LABEL')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('admin.SPORTS.TABLE.ACTIVE')), 1),
                _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('admin.ACTION')), 1),
                _hoisted_6
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(translatedSports), (sport) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: sport.id
                }, [
                  _createElementVNode("td", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(sport.id), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('admin.SPORTS.TABLE.IMAGE')), 1),
                    _createVNode(_component_SportImage, {
                      title: sport.translatedLabel,
                      "sport-label": sport.label,
                      color: sport.color
                    }, null, 8, ["title", "sport-label", "color"])
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('admin.SPORTS.TABLE.LABEL')), 1),
                    _createTextVNode(" " + _toDisplayString(sport.translatedLabel), 1)
                  ]),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('admin.SPORTS.TABLE.ACTIVE')), 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(`fa fa${sport.is_active ? '-check' : ''}`),
                      "aria-hidden": "true"
                    }, null, 2)
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('admin.ACTION')), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        class: _normalizeClass({ danger: sport.is_active }),
                        onClick: ($event: any) => (updateSportStatus(sport.id, !sport.is_active))
                      }, _toDisplayString(_ctx.$t(`buttons.${sport.is_active ? 'DIS' : 'EN'}ABLE`)), 11, _hoisted_17),
                      (sport.has_workouts)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                            _hoisted_19,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('admin.SPORTS.TABLE.HAS_WORKOUTS')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          (_unref(errorMessages))
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                message: _unref(errorMessages)
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push('/admin')), ["prevent"]))
          }, _toDisplayString(_ctx.$t('admin.BACK_TO_ADMIN')), 1)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})